"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SweepstakesService = void 0;
const api_1 = require("./api");
const PATH = 'sweepstakes/api/v1';
const PATH_V2 = 'sweepstakes/api/v2';
const INTERACTIVE_PATH = 'interactive/api/game';
class SweepstakesService {
    static async debitArcade(denomination, gameId) {
        try {
            return await api_1.API.post({
                url: `${PATH}/transaction/debit`,
                body: {
                    denomination,
                    gameId
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async debitArcadeV2(denomination, rewardKey) {
        try {
            return await api_1.API.post({
                url: `${PATH_V2}/transaction/debit`,
                body: {
                    denomination,
                    rewardKey
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getArcadeGameData(token) {
        try {
            return await api_1.API.get({
                url: `${INTERACTIVE_PATH}/play-arcade/${token}`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getDenominations(gameId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/transaction/${gameId}/denominations`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async playForFun(gameId) {
        try {
            return await api_1.API.post({
                url: `${PATH}/transaction/fun/${gameId}`
            });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.SweepstakesService = SweepstakesService;
//# sourceMappingURL=sweepstakes-service.js.map